import { forwardRef, ReactNode, useImperativeHandle, useState } from 'react';
import { OfflineModal } from './components/OfflineModal/OfflineModal';

export interface RequireBackendRef {
  showOfflineModal: () => void;
}

let requireBackendRef: RequireBackendRef | null = null;

export function showOfflineModal() {
  if (requireBackendRef) {
    requireBackendRef.showOfflineModal();
  } else {
    console.warn('RequireBackend component is not mounted.');
  }
}

export const RequireBackend = forwardRef<RequireBackendRef, { children: ReactNode }>(({ children }, ref) => {
  const [openModal, setOpenModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showOfflineModal: () => setOpenModal(true),
  }));

  requireBackendRef = { showOfflineModal: () => setOpenModal(true) };

  return (
    <>
      {children}
      {openModal && <OfflineModal setOpen={setOpenModal} open={openModal} />}
    </>
  );
});
